export const colors = [
  {
    color: 'primary',
    filled: 'bg-primary',
    toned: 'bg-primary/10 text-primary',
    outlined: 'border-primary text-primary',
    text: 'text-primary'
  },
  {
    color: 'secondary',
    filled: 'bg-secondary',
    toned: 'bg-secondary/10 text-secondary',
    outlined: 'border-secondary text-secondary',
    text: 'text-secondary'
  },
  {
    color: 'tertiary',
    filled: 'bg-tertiary',
    toned: 'bg-tertiary/10 text-tertiary',
    outlined: 'border-tertiary text-tertiary',
    text: 'text-tertiary'
  },
  {
    color: 'success',
    filled: 'bg-success',
    toned: 'bg-success-surface text-success',
    outlined: 'border-success text-success',
    text: 'text-success'
  },
  {
    color: 'info',
    filled: 'bg-info',
    toned: 'bg-info/10 text-info',
    outlined: 'border-info text-info',
    text: 'text-info'
  },
  {
    color: 'neutral',
    filled: 'bg-neutral',
    toned: 'bg-neutral/10 text-neutral',
    outlined: 'border-neutral text-neutral',
    text: 'text-neutral'
  },
  {
    color: 'good',
    filled: 'bg-good',
    toned: 'bg-good/10 text-good',
    outlined: 'border-good text-good',
    text: 'text-good'
  },
  {
    color: 'error',
    filled: 'bg-error',
    toned: 'bg-error/10 text-error',
    outlined: 'border-error text-error',
    text: 'text-error'
  },
  {
    color: 'warning',
    filled: 'bg-warning',
    toned: 'bg-warning-surface text-warning',
    outlined: 'border-warning text-warning',
    text: 'text-warning'
  },
  {
    color: 'black',
    filled: 'bg-black',
    toned: 'bg-black/10 text-black',
    outlined: 'border-black text-black',
    text: 'text-black'
  }
];
